import { BrandMark, Button, Spinner } from '../components/ui';

export function Splash({ message, retry, inline }: { message?: string; retry?: () => void; inline?: boolean }) {
  if (inline) {
    return (
      <div className="splash splash--inline">
        <Spinner size={18} />
      </div>
    );
  }
  return (
    <div className="splash">
      <div className="splash__mark">
        <BrandMark size={44} />
      </div>
      <div className="splash__word">
        AIRVIEW STUDIO <span>THE AVIATION PRODUCTION PLATFORM</span>
      </div>
      {message ? (
        <p className="splash__msg">{message}</p>
      ) : (
        <div className="splash__progress" role="progressbar" aria-label="Loading">
          <span />
        </div>
      )}
      {retry ? (
        <Button size="sm" icon="refresh" onClick={retry}>
          Retry
        </Button>
      ) : null}
    </div>
  );
}
